import { IconBuildingBank } from '@tabler/icons-react';
import { Button as MantineButton } from '@mantine/core';
import { useStyles } from './confirmBankModal.styles';
import { CustomModal } from '../../../components/customModal';

interface ConfirmBankModalProps {
  opened: boolean;
  onClose: () => void;
  onPrimaryBtnClick: () => void;
  onSecondaryBtnClick: () => void;
  selectedBankBranch: {
    name: string;
    ifsc: string;
    address: string;
    city: string;
    district: string;
    state: string;
    code: string;
  } | null;
}

export const ConfirmBankModal = (props: ConfirmBankModalProps) : JSX.Element => {
  const {
    opened, onClose, onPrimaryBtnClick, onSecondaryBtnClick,
    selectedBankBranch,
  } = props;
  const { classes } = useStyles();
  return (
    <CustomModal opened={opened} onClose={onClose} className={classes.modalWrapper}>
      <div className={classes.modalTextContainer}>
        <div className={classes.bankNameWrapper}>
          <IconBuildingBank className={classes.bankIcon} />
          <p>{selectedBankBranch?.name}</p>
        </div>
        <div className={classes.branchDetailsContainer}>
          <div className={classes.details}>
            <p className={classes.detailsTitle}>IFSC code </p>
            <b className={classes.detailsValue}>{selectedBankBranch?.ifsc}</b>
          </div>
          <div className={classes.details}>
            <p className={classes.detailsTitle}>Address </p>
            <b className={classes.detailsValue}>
              {' '}
              {selectedBankBranch?.address}
            </b>
          </div>
          <div className={classes.details}>
            <p className={classes.detailsTitle}>City </p>
            <b className={classes.detailsValue}>
              {' '}
              {selectedBankBranch?.city}
            </b>
          </div>
          <div className={classes.details}>
            <p className={classes.detailsTitle}>District </p>
            <b className={classes.detailsValue}>
              {' '}
              {selectedBankBranch?.district}
            </b>
          </div>
          <div className={classes.details}>
            <p className={classes.detailsTitle}>State </p>
            <b className={classes.detailsValue}>
              {' '}
              {selectedBankBranch?.state}
            </b>
          </div>
        </div>
      </div>
      <div
        className={classes.modalBtnContainer}
      >
        <MantineButton
          radius={8}
          variant="outline"
          onClick={onSecondaryBtnClick}
          fullWidth
        >
          Not my bank
        </MantineButton>
        <MantineButton
          fullWidth
          radius={8}
          onClick={onPrimaryBtnClick}
        >
          Looks Good
        </MantineButton>
      </div>
    </CustomModal>
  );
};

export default ConfirmBankModal;
